var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52611",
    "data-name": "Group 52611",
    transform: "translate(-158 -577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18644",
    "data-name": "Rectangle 18644",
    transform: "translate(158 577)",
    fill: "none",
    stroke: "#93a750",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 83,
    height: 83,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_6_",
    "data-name": "svgexport-7 (6)",
    transform: "translate(168.221 587.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90986",
    "data-name": "Path 90986",
    d: "M224.581,0H200.646A7.841,7.841,0,0,0,192.8,7.845v35.9a1.863,1.863,0,0,0,2.979,1.49l7.481-5.611h21.319a7.841,7.841,0,0,0,7.846-7.846V7.845A7.841,7.841,0,0,0,224.581,0ZM210.751,29.653h-8.11a1.862,1.862,0,1,1,0-3.724h8.11a1.862,1.862,0,1,1,0,3.724Zm11.835-7.978H202.641a1.862,1.862,0,0,1,0-3.724h19.945a1.862,1.862,0,1,1,0,3.724Zm0-7.978H202.641a1.862,1.862,0,0,1,0-3.724h19.945a1.862,1.862,0,1,1,0,3.724Zm0,0",
    transform: "translate(-168.867)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90987",
    "data-name": "Path 90987",
    d: "M42.03,249.791a8.8,8.8,0,1,1-8.8-8.8A8.8,8.8,0,0,1,42.03,249.791Zm0,0",
    transform: "translate(-21.393 -211.072)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90988",
    "data-name": "Path 90988",
    d: "M11.835,382.8A11.835,11.835,0,0,0,0,394.64v2.342a1.862,1.862,0,0,0,1.862,1.862H21.807a1.862,1.862,0,0,0,1.862-1.862V394.64A11.835,11.835,0,0,0,11.835,382.8Zm0,0",
    transform: "translate(0 -335.284)",
    fill: "#93a750"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestRequest);
export default __webpack_public_path__ + "static/media/TestRequest.532c802963d0d7c713066901ec63010e.svg";
export { ForwardRef as ReactComponent };